import { getAllowActionByCurrRole } from "@/utils/get-roles";
const INIT_FILTER_VALUE = {
  osm: null,
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  advance_filter: false,
  start_date: null,
  end_date: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  //   START: address
  setAddress({ commit }, address) {
    commit("setAddress", address);
  },
  setAmphur({ commit }, amphur) {
    commit("setAmphur", amphur);
  },
  setProvince({ commit }, province) {
    commit("setProvince", province);
  },
  setTumbol({ commit }, tumbol) {
    commit("setProvince", tumbol);
  },
  setVillage({ commit }, village) {
    commit("setVillage", village);
  },
  //   END: address
  setOsm({ commit }, osm) {
    commit("setOm", osm);
  },
};

// mutations
const mutations = {
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  //   START: address
  setAddress(state, address) {
    state.address = address;
  },
  setProvince(state, province) {
    state.address.province = province;
  },
  setAmphur(state, amphur) {
    state.address.amphur = amphur;
  },
  setTumbol(state, tumbol) {
    state.address.tumbol = tumbol;
  },
  setVillage(state, village) {
    state.address.village = village;
  },
  //   END: address
  setOsm(state, osm) {
    state.osm = osm;
  },
};
const getters = {
  address: (state) => state.address,
  province: (state) => state.address.province,
  amphur: (state) => state.address.amphur,
  tumbol: (state) => state.address.tumbol,
  village: (state) => state.address.village,
  osm: (state) => state.osm,
  start_date: (state) => state.start_date,
  end_date: (state) => state.end_date,
  getAllFilter: (state) => {
    if (state.advance_filter) return state;
    const commonFilter = {
      ...state,
    };
    return commonFilter;
  },
  getCommonFilter: (state) => {
    const commonFilter = {
      address: {
        amphur: state.address.amphur,
        province: state.address.province,
        tumbol: state.address.tumbol,
        village: state.address.village,
      },
      osm: state.osm,
      start_date: state.start_date,
      end_date: state.end_date,
    };
    return commonFilter;
  },
  getFilterSummaryArray: (state, getters, rootState, rootGetters) => {
    let prepareState = { ...state };
    if (!state.advance_filter)
      prepareState = {
        ...prepareState,
      };

    let result = [];
    // address
    if ((prepareState.address.province || getAllowActionByCurrRole("default-provinceCode-search")) && !prepareState.osm)
      result.push({
        title: "จังหวัด",
        text: prepareState.address.province ? prepareState.address.province.province_name : rootGetters["userAuth/getTokenParsed"]['provinceName'],
      });
    if (prepareState.address.amphur)
      result.push({
        title: "อำเภอ/เขต",
        text: prepareState.address.amphur.amphur_name,
      });
    if (prepareState.address.tumbol)
      result.push({
        title: "ตำบล/แขวง",
        text: prepareState.address.tumbol.tumbol_name,
      });
    if (prepareState.address.village)
      result.push({
        title: "หมู่บ้าน",
        text: prepareState.address.village.village_name,
      });
    if (prepareState.osm) {
      result.push({
        title: "สสว.",
        text: prepareState.osm.text,
      });
    }
    if (prepareState.start_date && prepareState.end_date) {
      result.push({
        title: "วันเริ่มต้น-วันสิ้นสุด",
        text: `${displayThaiDate(prepareState.start_date)} - ${displayThaiDate(
          prepareState.end_date
        )}`,
      });
    }
    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    // if (state.address.province)
    //every role except tpso, dv, et or action include default-provinceCode-search send provCode for default
    if (
      !state.osm &&
      (getAllowActionByCurrRole("default-provinceCode-search") ||
        state.address.province)
    ) {
      result.prov = state.address.province
        ? state.address.province._id.province_ID.toString()
        : rootGetters["userAuth/getTokenParsed"]["provinceCode"].toString();
    }
    if (state.address.amphur)
      result.amp = state.address.amphur._id.amphur_ID.toString();
    if (state.address.tumbol)
      result.tam = state.address.tumbol._id.tumbol_ID.toString();
    if (state.address.village)
      result.vil = state.address.village._id.village_ID.toString();

    if (state.start_date) result.start_date = state.start_date;
    if (state.end_date) result.end_date = state.end_date;
    //if action include default-cm_uid-search send cm_uid for default
    if (getAllowActionByCurrRole("default-cm_uid-search"))
      result.cm_uid = rootGetters["userAuth/getUsername"];
    //role action include default-osmCode-search send osmCode for default
    if (getAllowActionByCurrRole("default-osmCode-search") || state.osm) {
      result.osm = state.osm
        ? state.osm.value
        : rootGetters["userAuth/getTokenParsed"]["osmCode"].toString();
    }
    return result;
  },
};
function displayThaiDate(date) {
  let newdate = new Date(date);
  const day = ("0" + newdate.getDate()).slice(-2);
  const month = ("0" + (newdate.getMonth() + 1)).slice(-2);
  const year = newdate.getFullYear() + 543;
  return `${day}/${month}/${year}`;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
